/* Velvet Bags — hide the product recommendations block when Shopify returns
   nothing for it, so the product page never ends in empty grey placeholders.
   If recommendations start resolving later, the block shows normally again. */
(function () {
  'use strict';

  function prune() {
    var blocks = document.querySelectorAll('product-recommendations');
    if (!blocks.length) return;

    blocks.forEach(function (block) {
      var settled = false;

      function evaluate() {
        if (settled) return;
        var host = block.closest('.shopify-section') || block;
        if (block.querySelector('img')) {
          settled = true;
          host.style.removeProperty('display');
          return;
        }
        host.style.display = 'none';
      }

      /* Give the section-rendering request time to resolve first. */
      setTimeout(evaluate, 1800);
      setTimeout(evaluate, 4000);

      if ('MutationObserver' in window) {
        var mo = new MutationObserver(function () {
          if (block.querySelector('img')) {
            settled = true;
            var host = block.closest('.shopify-section') || block;
            host.style.removeProperty('display');
            mo.disconnect();
          }
        });
        mo.observe(block, { childList: true, subtree: true });
        setTimeout(function () { mo.disconnect(); }, 8000);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prune);
  } else {
    prune();
  }
  document.addEventListener('shopify:section:load', prune);
})();
